// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-q_fZ","galleryItem_borderTopRadius":"c-q_ga","galleryItem__image":"c-q_gb"};